import Cookies from "js-cookie";
import qs from 'query-string'
import saveAs from 'file-saver';
import cdp from 'content-disposition'

export const endpoint = window?.optima?.$optimaUrls?.Shell || window?.selfie?.$optimaUrls?.Shell || "/api/"
export const endpointAPI = window?.optima?.$optimaUrls?.WebAPIPath || window?.selfie?.$optimaUrls?.WebAPIPath || "/api/next/"

const cookies = Cookies.get();

const fetchOptions = () => {
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json;charset=UTF-8",
    "X-XSRF-TOKEN": cookies["XSRF-TOKEN"],
    "timeZoneName": Intl.DateTimeFormat().resolvedOptions().timeZone
  }
  const user = window.$user || window.user || window.optima?.user || window.SelfieSettings?.settings?.user
  if (user?.UserToken) {
    headers["JWT"] = user.UserToken
  }
  return {
    headers, credentials: "same-origin"
  }
}

export const GET = async (resource, query, exurl) => {
  let url = "";
  const baseURL = resource.includes("next") ? endpointAPI : endpoint;
  resource = resource.replace('next/', '');

  url = exurl || baseURL + resource;
  if (query) {
    url = qs.stringifyUrl({ url, query });
  }
  let config = {
    method: "GET",
    ...fetchOptions()
  };
  const response = await fetch(url, config);
  return handleResponse(response);
}

export const POST = async (resource, data, exurl, query) => {
  let url = "";
  const baseURL = resource.includes("next") ? endpointAPI : endpoint;
  resource = resource.replace('next/', '');

  url = exurl || baseURL + resource;
  if (query) {
    url = qs.stringifyUrl({ url, query });
  }
  let config = {
    method: "POST",
    body: JSON.stringify(data),
    ...fetchOptions()
  };
  const response = await fetch(url, config);
  return handleResponse(response);
}

export const PUT = async (resource, data, exurl) => {
  let url = "";
  const baseURL = resource.includes("next") ? endpointAPI : endpoint;
  resource = resource.replace('next/', '');

  url = exurl || baseURL + resource;
  let config = {
    method: "PUT",
    body: JSON.stringify(data),
    ...fetchOptions()
  };
  const response = await fetch(url, config);
  return handleResponse(response);
}

export const PATCH = async (resource, data, fields, exurl) => {
  let url = "";
  const baseURL = resource.includes("next") ? endpointAPI : endpoint;
  resource = resource.replace('next/', '');

  url = exurl || baseURL + resource;

  if (fields) {
    url = qs.stringifyUrl({ url, query: {fields} });
  }
  let config = {
    method: "PATCH",
    body: JSON.stringify(data),
    ...fetchOptions()
  };
  const response = await fetch(url, config);
  return handleResponse(response);
}

export const DELETE = async (resource, id, exurl) => {
  let url = "";
  const baseURL = resource.includes("next") ? endpointAPI : endpoint;
  resource = resource.replace('next/', '');
  url = exurl || baseURL + resource

  if (Array.isArray(id)) {
    url = qs.stringifyUrl({ url, query: {ids: id} });
  } else {
    url += '/' + id;
  }

  let config = {
    method: "DELETE",
    ...fetchOptions()
  };
  const response = await fetch(url, config);
  return handleResponse(response);
}

const handleResponse = async res => {
  const cdh = res.headers.get("Content-Disposition")
  if (cdh) {
    const attachment = cdp.parse(cdh)
    if (attachment?.type === "attachment") {
      const blob = await res.blob()
      saveAs(blob, attachment.parameters.filename)  
      return Promise.resolve()
    }
  }
  
  const text = await res.text()
  let json;
  try {
    if(text) json = JSON.parse(text)
  } catch (e) {
    console.error(e)
  }

  if (res.status === 200) {
    return json || text
  } else if (res.status === 401) {
    return Promise.reject({ status: res.status, error: res.statusText });
  } else {
    return Promise.reject({ status: res.status, error: json || text });
  }
}